// 公共配置文件：统一管理基础路径、接口常量、环境配置等

// 环境判断（根据打包环境自动切换，也可手动指定）
const env = process.env.NODE_ENV || 'production'; // 默认为开发环境

// 不同环境的配置项
const envConfig = {
  // 开发环境（本地）
  development: {
    baseApiUrl: 'https://xcxhoutai.tsajjt.com', // 本地接口基础路径 http://127.0.0.1:18081
  },
  // 测试环境（服务器网址）
  test: {
    baseApiUrl: 'https://xcxhoutai.tsajjt.com', // 服务器基础路径
  },
  // 生产环境（服务器域名）
  production: {
    baseApiUrl: 'https://xcxhoutai.tsajjt.com', // 域名基础路径
  }
};

// 导出当前环境的配置（默认开发环境）
module.exports = {
  ...envConfig[env], // 展开当前环境的基础路径配置
  uploadMaxSize: 2 * 1024 * 1024, // 2MB（通用配置）
  requestTimeout: 30000 // 请求超时（通用配置）
};